<template>
  <div class="status-chip " :style="{ background: colorHex }">
    <span class="aisea-text-12-700-white">{{ label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
    },
    label: {
      type: String,
    },
  },
  computed: {
    colorHex() {
      return this.color ? `#${this.color}` : `#039BE5`;
    },
  },
};
</script>

<style lang="scss" scoped>
.status-chip {
  min-width: 70px;
  max-width: 70px;
  height: 24px;
  border-radius: 6px;
  color: white;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
